import moment from 'moment';

import type { BaseOptionType } from 'antd/es/select';

export const generatePlanYearsRange = (startYear: number): BaseOptionType[] => {
  const currentYear = moment().year();
  const endYear = currentYear + 3;
  const yearsSet = new Set<number>();
  yearsSet.add(currentYear);

  for (let y = currentYear - 1; y >= startYear; y--) {
    yearsSet.add(y);
  }
  for (let y = currentYear + 1; y <= endYear; y++) {
    yearsSet.add(y);
  }

  const sortedYears = Array.from(yearsSet).sort((a, b) => a - b);

  return sortedYears.map((value) => ({
    value,
    label: value,
  }));
};
